// License and Permission
const LicensePermission = {
  // License
  QHSE_MANAGEMENT: "QHSE Management",
  PROJECT_MANAGEMENT: "Project Management",
  EQUIPMENT_MANAGEMENT: "Equipment Management",
  WFM_WIZARD: "WFM Wizard",
  RESOURCE: "Resource",
  PERSONNEL_MANAGEMENT: "Personnel Management",

  // Permissions
  SAFE_CARD: "Safe",
  UNSAFE_CARD: "Unsafe",
  NCR_CARD: "NCR",
  INCIDENT_CARD: "Incident",
  SHIFT_DETAILS: "Shift Details",
  REPORT: "Report",
  TRACKERS: "Project Trackers",
  PROJECT_MAP: "Project Map",
  SNAG: "Snag",
  DPR: "DPR",
  INVENTORY: "Inventory",
  WAREHOUSE: "Warehouse",
  ORDER_APPROVAL: "Order Approval",
  EQUIPMENT_REQUEST: "Request",
  USER_MANAGEMENT: "Personnel",
  CERTIFICATE_APPROVAL: "Certificate Approval",
  TRAINING_MATRIX: "Training Matrix",
  TOOLBOX_TALK: "Toolbox Talk",
  SAFETY_ALERT_GLOBAL: "Safety Alert (Global)",
};

export default LicensePermission;
